/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import type { EuiIconProps } from '@elastic/eui'
import { EuiIcon } from '@elastic/eui'

import { getPlatform, getPlatformInfoById } from '@modules/utils/platform'

import type { FunctionComponent } from 'react'

type Props = {
  regionId?: string | null
  size?: EuiIconProps['size']
}

const DeploymentProvider: FunctionComponent<Props> = ({ regionId, size = 'xl' }) => {
  if (!regionId) {
    return null
  }

  if (regionId === `ece-region`) {
    return null
  }

  const platformId = getPlatform(regionId)
  const platform = getPlatformInfoById(platformId)

  if (!platform) {
    return null
  }

  return <EuiIcon type={platform.iconType} aria-label={platform.title} size={size} />
}

export default DeploymentProvider
